import BaseService from '../base';
import {keycloak} from "../../keycloak/keycloak";
import {toast} from "react-toastify";

const apiService = new BaseService(
    process.env.REACT_APP_VISUALS_API_URL + '/v1/order',
    {}
);

export function getOrder(id) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json',
    };
    return apiService.get(`/${id}`, null, { headers }).then(res => res.data);
}

export function createOrder() {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json',
    };
    return apiService.post('', null, { headers })
        .then(res => {
            toast.success('Order created successfully');
            return res.data
        });
}

export function updateOrder(id, updateData) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json',
    };
    return apiService.patch(`/${id}`, updateData, { headers })
        .then(res => {
            toast.success('Order updated successfully');
            return res.data
        });
}


export function updateOrderStatus(id, orderStatus) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json',
    };
    return apiService.put(`/${id}/status`, orderStatus , { headers })
        .then(res => {
            toast.success('Order status updated successfully');
           return res.data
        });
}

export function createProductSnapshot(orderId, snapshotData) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json',
    };
    return apiService.post(`/${orderId}/product-snapshot`, snapshotData, { headers })
        .then(res => {
            toast.success('Add product successfully');
            return res.data
        });
}

export function updateProductSnapshot(snapshotData) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json',
    };
    return apiService.patch('/product-snapshot', snapshotData, { headers })
        .then(res => {
            toast.success('Product updated successfully');
            return res.data
        });
}

export function searchOrders(searchParams, pageable) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json',
    };
    return apiService.get('', { ...searchParams, ...pageable }, { headers })
        .then(res => res.data);
}


export async function saveProformaInvoice(orderId) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.post(`/${orderId}/proforma-invoice/save`, null, {headers: headers})
            .then(result => {
                toast.success('Proforma invoice saved successfully');
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function downloadProformaInvoicesAllZip(orderId) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/zip',
    };

    return await apiService.get(`/${orderId}/proforma-invoice/saved`, null, {
        headers,
        responseType: 'blob'
    }).then((res) => {
        const blob = new Blob([res.data], { type: 'application/zip' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `proforma-invoices-${orderId}.zip`;
        link.click();
        toast.success('Proforma invoices downloaded successfully');
    });
}


export function downloadProformaInvoice(payload) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/pdf',
    };

    return apiService.get(`/${payload.orderId}/proforma-invoice?type=${payload.type}`, null, {
        headers,
        responseType: 'blob'
    }).then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `proforma-invoice-${payload.orderId}.pdf`;
        link.click();
        toast.success('Proforma invoice downloaded successfully');
    });
}

export async function deleteProductSnapshot(orderId, productSnapshotId) {
    if (!keycloak.authenticated) throw new Error('Not authenticated');
    const headers = {
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': '*/*',
    };
    return await apiService.delete(`/${orderId}/product-snapshot`, {
        headers: headers,
        params: {
            productSnapshotId: productSnapshotId,
        },
    }).then(res => {
            toast.success('Product removed successfully');
            return res.data
        });
}
